import { render, staticRenderFns } from "./RequestPassword.vue?vue&type=template&id=b964d1fe"
import script from "./RequestPassword.vue?vue&type=script&lang=js"
export * from "./RequestPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports